import React from 'react'

export default class DetalheAgencia extends React.Component {
  render () {
    if (!this.props.agencia.exibirConteudo) {
      return ''
    }

    return (
      <div className="vx-row-detail">
        <div className="vx-row-detail-title">Usuários</div>
        {this.props.agencia.detalhamento && this.props.agencia.detalhamento.length
          ? this.props.agencia.detalhamento.map(it => (
            <div key={'usuario_' + it.id} style={{ display: 'flex', gap: 24, flexWrap: 'wrap', padding: '4px 0', fontSize: 13, color: '#444' }}>
              <span><strong style={{ color: '#333' }}>{it.nomeComNumero}</strong></span>
              <span>{it.email}</span>
              <span>{it.telefone ? it.telefone : 'Não informado'}</span>
            </div>
          ))
          : <div className="vx-row-detail-empty">Agência sem usuários cadastrados</div>}
      </div>
    )
  }
}
